<template>
  <div class="body_container">
    <Contact></Contact>
    <div class="width_margin">
      <div class="container_content_list_title">
        글로벌 직무<br />
        <span class="container_content_list_title_span"
          >대면 / 비대면(실시간 화상)</span
        >
      </div>
    </div>

    <div class="width_margin">
      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication9.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#직무/산업별</div>
            </div>
          </div>
        </div>
        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              글로벌 직무역량 강화 과정 (On the job English)
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            Global Standard 수준의 직무 역량 경쟁력 강화로 해당 직무 및 산업에
            따라 맞춤형 학습을 제공합니다.
          </div>
          <div class="container_content_text_content">
            직무, 산업별 실무 영역에서의 비즈니스 커뮤니케이션을 강화하여 Global
            Standard 수준의 직무 역량 경쟁력 강화<br />
            HR, 자동차 산업, IT 산업, 금융 산업, 생산 및 건설 등 사례 학습을
            통한 직무역량 강화<br />
            해외 현지 업무 수행이 필요한 주재원, 지사장 대상 현업 Case Study를
            통해 사전 현업 이해도를 강화
          </div>
        </div>
      </div>

      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication10.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#항공/방산</div>
            </div>
          </div>
        </div>

        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              항공 및 방산 회화 과정
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            항공, 방산 분야의 용어 및 영어 말하기 스킬을 습득하여 직무 중심의
            글로벌 전문 인력을 양성하는 과정입니다.
          </div>
          <div class="container_content_text_content">
            항공 및 방산 현장의 글로벌 커뮤니케이션을 위한 과정으로 직무 관련된
            정확한 의사소통 훈련에 집중<br />
            항공관련 용어 및 Radio Communication, 방산 용어 및 토픽에 대한
            이해로 효과적인 직무능력 향상<br />
            전투조종사 교육 등의 레퍼런스를 바탕으로, EPTA Test 대비 교육 및
            맞춤 컨설팅 제공<br />
            Aviation English, Military English 등 자체 콘텐츠 개발, 맞춤 교육에
            활용
          </div>
        </div>
      </div>

      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication11.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#의료/보건</div>
            </div>
          </div>
        </div>

        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              의료보건산업분야 글로벌 인력양성 과정
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            글로벌 환경에서 의료보건산업분야를 선도할 글로벌 핵심인재를
            양성하여, 글로벌 의료보건산업 비즈니스의 성장을 견인하는 프로그램
            입니다.
          </div>
          <div class="container_content_text_content">
            글로벌 헬스케어, 병원, 제약회사, 의료기기 등 글로벌
            의료보건산업분야를 선도할 글로벌 인재 육성 및 사업 성장 목적<br />
            글로벌 업무 수행에 필요한 의료, 의약, 보건 사업을 전반적으로
            이해하고 관련 용어 및 산업 이슈를 in-depth한 토론으로 산업경쟁력
            강화<br />
            해당 산업에 따른 맞춤형 3단계 교육과정 제공 : 1) 직무이해 학습 2)
            직무 실전 훈련 3) 문제 해결 능력 및 제시 훈련
          </div>
        </div>
      </div>

      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication12.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#이공계 논문</div>
            </div>
          </div>
        </div>

        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              이공계 영어 논문 역량 향상 과정
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            이공계 영어 논문에 대한 이해와 논문을 읽고 작성하는 방법을
            체계적으로 학습하는 과정입니다.
          </div>
          <div class="container_content_text_content">
            Impact factor가 높은 논문 검색 방법, 업무 유관 논문 리딩 및 핵심
            도출법 학습<br />
            논문의 기본 구조 및 주요 영문 표현, 한국 연구자들이 흔히 실수하는
            영문 오류 등에 대한 교육<br />
            이공계 SCI급 논문 작성이 성과인 임직원 대상으로 기초부터 논문 작성,
            피드백까지 제공
          </div>
        </div>
      </div>

      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication13.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#사내 강사</div>
            </div>
          </div>
        </div>

        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              글로벌 사내 강사 양성 과정
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            실전 위주의 교육 프로그램을 통해 사내 전문 강사를 양성하고, 해외
            현지 채용인 대상으로 교육 전달 효과를 높입니다.
          </div>
          <div class="container_content_text_content">
            해외 지사, 법인의 HRD 역량 내재화를 위해 사내 강사 양성을
            준비하시거나 더 효율적인 양성 과정가 필요하신 기업 대상<br />
            Global facilitator 양성을 목적으로 강사 마인드, 교수법 훈련, 실전
            시강 및 Contents Delivery의 효율성 증대 훈련<br />
            현채인들에게 본사의 핵심 가치와 문화, 비즈니스 현황을 명확히 전달할
            수 있도록 OJT 및 facilitation 할 수 있는 기법과 역량 향상
          </div>
        </div>
      </div>

      <!-- <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication14.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#현지 파견</div>
            </div>
          </div>
        </div>

        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              지역전문가 양성 과정
            </div>
          </div>
          <div class="container_content_text_title">
            지역전문가 양성을 위한 글로벌 커뮤니케이션 훈련과 글로벌 역량 진단,
            마인드셋, 현지 위탁교육, 심리지원 및 출국 프로세스까지 통합 솔루션을
            제공합니다.
          </div>
          <div class="container_content_text_content">
            -파견 전 글로벌 역량진단부터 글로벌 마인드, 글로벌 리더십까지 통합
            교육 진행으로 지역전문가를 양성하기 위한 토탈 솔루션 제공<br />
            -파견 시 장기적인 현지 교육 (대학, 어학원 등) 에 대한 맞춤 솔루션,
            장기적인 역량강화 프로그램 제공<br />
            -파견 중 지원 프로그램 제공 (심리지원 및 현지 멘토 서비스),
            지역전문가용 전용 플랫폼 제공 (현지 에세이, ucc 관리)
          </div>
        </div>
      </div> -->

      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication49.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">
                #팀워크/로열티
              </div>
            </div>
          </div>
        </div>

        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              신입사원 글로벌 역량 강화 과정
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            회사와 고객에 대한 이해로 창의성 함양, 글로벌 역량 강화,
            커뮤니케이션 스킬 향상을 도모하는 실습 중심의 과정입니다.
          </div>
          <div class="container_content_text_content">
            글로벌 시장 관점에서 Global challenge를 통해 Global mind-set 증진과
            회사 로열티 제고<br />
            에너지와 혁신성을 키우는 팀빌딩, 이문화 이해, 글로벌 팀워크 훈련
            activity 등으로 EXPO 준비<br />
            회사 이해 교육 기반 실제 이슈와 케이스를 바탕으로 EXPO 준비, 게스트
            대상 프레젠테이션 실시
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contact from "@/components/Global/ContactUs.vue";
export default {
  components: { Contact },
  name: "Duty",
};
</script>

<style></style>
